
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
    import * as Preguntas from '@/__env/lib/Cursos/Preguntas';
    import { Opcion } from '@/__env/lib/Cursos/Preguntas/Opciones/Opcion.nav';
    import { Random } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {



        @Prop()
        public Editando: Pregunta;


        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            this.$nextTick( () => { this.Abierto = true; } );
        }

        public Opciones: { Valor: string, Correcta: boolean; }[] = [];
        public Pregunta: string = '';
        public Opcion: string = '';
        public Id: number = 0;
        public Tipo: string = 'unica';

        public async Guardar()
        {
            if ( !this.Pregunta || !this.Opciones.hasRows() )
                return;

            if ( this.Opciones.findIndex( x => x.Correcta ) == -1 )
            {
                this.$EventBus.Notificaciones.Info( 'Al menos una opción debe ser correcta' );
                return;
            }

            if ( this.Opciones.findIndex( x => !x.Correcta ) == -1 )
            {
                this.$EventBus.Notificaciones.Info( 'Al menos una opción debe ser incorrecta' );
                return;
            }

            this.Tipo = this.Opciones.filter( x => x.Correcta == true ).length > 1 ? 'multiple' : 'unico';

            let pre = new Pregunta();
            pre.Tipo = Preguntas.Tipos.toTipo( this.Tipo );
            pre.Id = this.Id;
            pre.Pregunta = this.Pregunta;
            pre.Opciones = this.Opciones.map( x =>
            {
                let o = new Opcion();
                o.Opcion = x.Valor;
                o.Correcta = x.Correcta;

                return o;
            } );
            this.$emit( 'agregar', pre );
            this.Abierto = false;
        }

        public AgregarOpcion()
        {
            if ( !this.Opcion )
                return;

            this.Opciones.push( { Valor: this.Opcion, Correcta: false } );
            this.Opcion = '';
        }

        public EliminarOpcion( index: number )
        {
            this.Opciones.splice( index, 1 );
        }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        async onAbierto()
        {
            if ( this.Abierto )
            {
                if ( this.Editando )
                {
                    this.Id = this.Editando.Id;
                    this.Pregunta = this.Editando.Pregunta;
                    this.Tipo = this.Editando.Tipo.Id;
                    this.Opciones = this.Editando.Opciones.map( x =>
                    {
                        return {
                            Valor: x.Opcion,
                            Correcta: x.Correcta,
                        };
                    } );
                }
                else
                {
                    this.Id = Random.Enteros( 1000, 50000 );
                    this.Pregunta = '';
                    this.Opciones.clear();
                }
            }
        }
        public Estado: 'cargando' | 'guardando' | 'guardado' | 'error-al-guardar' | 'ok' | 'error' | 'vacio' | 'iniciado' = 'iniciado';

    }
